export default "__VITE_ASSET__DNqrTFU___"